import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=3d5141be&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5141be')) {
      api.createRecord('3d5141be', component.options)
    } else {
      api.reload('3d5141be', component.options)
    }
    module.hot.accept("./MenuButton.vue?vue&type=template&id=3d5141be&", function () {
      api.rerender('3d5141be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuButton.vue"
export default component.exports